import xss from "xss"

export default s => {
    return xss(s, {
        onTagAttr(tag, name, val, isWhiteAttr){
            return filter(tag,name,val,isWhiteAttr)
        },
        onIgnoreTagAttr(tag, name, val, isWhiteAttr) {
            return filter(tag,name,val,isWhiteAttr)
        }
    }).replace(/\<\/?div\>/ig,"");
};

const filter = (tag, name, val, isWhiteAttr)=>{
    if(/code|pre|span/i.test(tag)) {
        // if(/style|class/i.test(name)) return name+"='"+xss.escapeAttrValue(val)+"'"
        if(name == "style") {
            let match = val.match(/color:([#a-z0-9]{3,7}|\s+[#a-z0-9]{3,8})/gi)
            if(!!match && match.length) return 'style="'+match[0]+'"'
            return ''
        }
        if(name == 'class') return name+"='"+xss.escapeAttrValue(val)+"'"
    }
    if(tag === 'a' && name == "class" && val === 'at') return name+"='"+xss.escapeAttrValue(val)+"'"
    if (tag === 'img' && /src|class/i.test(name)) return name + "='"+xss.escapeAttrValue(val) + "' referrerPolicy='no-referrer'"
    // if (name === "style") return String(val).indexOf('color') > -1 ? `${name}="${xss.escapeAttrValue(String(val))}"` : name+"=''"
}